module.exports = __webpack_public_path__ + "static/img/fundamentals.e95f552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/products/fundamentals.png
// module id = 28QU
// module chunks = 0